const LogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    aria-label="MKS"
  >
    <rect width="32" height="32" rx="4" fill="#ff7900" />
    <text
      x="16"
      y="22"
      textAnchor="middle"
      fill="#000000"
      fontFamily="Helvetica Neue, Helvetica, Arial, sans-serif"
      fontWeight="700"
      fontSize="13"
    >
      MKS
    </text>
  </svg>
);

export default LogoIcon;
